import React, {Component} from 'react';
import {Route, withRouter} from 'react-router-dom';
import PayletterResult from './Payletter/PayletterResult';
import PayletterClose from './Payletter/PayletterClose';
import './Payment.scss';

class Payment extends Component {
  render() {
    return (
      <div>
        <Route path="/payment/payletter/result" component={PayletterResult} />
        <Route path="/payment/payletter/close/:result" component={PayletterClose} />
      </div>
    );
  }
}

export default withRouter(Payment);
